/*
 * @创建文件时间: 2021-06-01 22:41:21
 * @Auther: 猿小天
 * @最后修改人: 猿小天
 * @最后修改时间: 2021-08-13 00:06:07
 * 联系Qq:1638245306
 * @文件介绍: 登录和登出
 */
// import { Message, MessageBox } from 'element-ui'
import util from '@/libs/util.js'
import router from '@/router'
import store from '@/store/index'
import { SYS_USER_LOGIN, SYS_USER_LOGOUT } from '@/views/login/api'
import Cookies from 'js-cookie'

export default {
   namespaced: true,
   actions: {
      /**
       * @description 登录
       * @param {Object} context
       * @param {Object} payload username {String} 用户账号
       * @param {Object} payload password {String} 密码
       * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
       */
      async login({ dispatch }, data = {}) {
         // let res = await SYS_USER_LOGIN(data)
         // console.log(res,'resresres')
         // if(res.status_code == 0 && res.data){
         //   res = res.data
         //   util.cookies.set('userId', res.userid)

         //   // 设置 vuex 用户信息
         //   await dispatch('tccc/user/set', res, { root: true })
         //   // 用户登录后从持久化数据加载一系列的设置
         //   await dispatch('load')
         // }
         // 设置 cookie 一定要存 uuid 和 token 两个 cookie
         // 整个系统依赖这两个数据进行校验和存储
         // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
         // token 代表用户当前登录状态 建议在网络请求中携带 token
         // 如有必要 token 需要定时更新，默认保存一天
         let res = {
            status_code: 0,
            data: {
               userid: 'wangyanhui',
               test: '123',
            },
         }

         if (res.status_code == 0 && res.data) {
            res = res.data
            util.cookies.set('userid', res.userid)
            // 设置 vuex 用户信息
            await dispatch('tccc/user/set', res, { root: true })
            // 用户登录后从持久化数据加载一系列的设置
            await dispatch('load')
            // 进入页面
            // router.go(0)
         } else {
            // 获取用户信息失败
         }
      },
      /**
       * @description 注销用户并返回登录页面
       * @param {Object} context
       * @param {Object} payload confirm {Boolean} 是否需要确认
       */
      logout({ commit, dispatch }, { confirm = false } = {}) {
         /**
          * @description 注销
          */
         async function logout() {
            await SYS_USER_LOGOUT({
               refresh: util.cookies.get('refresh'),
            }).then(() => {
               // 删除cookie
               util.cookies.remove('token')
               util.cookies.remove('uuid')
               util.cookies.remove('refresh')

               util.cookies.remove('client_id')
               util.cookies.remove('platform')

               Cookies.remove('gray_user_id')
            })
            // 清空 vuex 用户信息
            await dispatch('tccc/user/set', {}, { root: true })

            store.dispatch('tccc/db/databaseClear')
         }
         // 判断是否需要确认
         if (confirm) {
            commit('tccc/gray/set', true, { root: true })
            MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
               type: 'warning',
            })
               .then(() => {
                  commit('tccc/gray/set', false, { root: true })
                  logout()
               })
               .catch(() => {
                  commit('tccc/gray/set', false, { root: true })
                  Message({ message: '取消注销操作' })
               })
         } else {
            logout()
         }
      },
      /**
       * @description 用户登录后从持久化数据加载一系列的设置
       * @param {Object} context
       */
      async load({ dispatch }) {
         // 加载用户名
         await dispatch('tccc/user/load', null, { root: true })
         await dispatch('tccc/client/load', null, { root: true })
         await dispatch('tccc/page/openedLoad', null, { root: true })
         await dispatch('tccc/individualCenter/load', null, { root: true })
         await dispatch('tccc/configuration/load', null, { root: true })
      },
   },
}
